import content from '@/mixins/content'
import searchInList from '../../../utils/searchInList'

export default {
  mixins: [content],

  props: {
    propBus: {
      type: Object,
    },
  },

  computed: {
    internal() {
      const internal = searchInList.searchByName(this.document, 'legal.internal')

      return internal
    },

    footer() {
      return {
        ...this.$t('components.footer'),
        availableLocales: ['pt-BR', 'en', 'es', 'fr'],
      }
    },
  },
}
